import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

// Usage: <ProtectedRoute><YourComponent /></ProtectedRoute>
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // or a loading spinner

  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

  if (!user) {
    // Not logged in: allow only login/register, redirect others to login
    if (isAuthPage) {
      return children;
    }
    return <Navigate to="/login" replace />;
  } else {
    // Logged in: redirect login/register to home
    if (isAuthPage) {
      return <Navigate to="/" replace />;
    }
    return children;
  }
}
